var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c("v-data-table", {
            staticClass: "schedules-table",
            attrs: {
              headers: _vm.headers,
              items: _vm.schedules,
              loading: _vm.loading,
              "item-key": "schedule_id",
              "item-class": _vm.rowClass,
              "hide-default-footer": "",
              "no-data-text": "No scheduled deliveries yet"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.template_id",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.templateName(item.template_id)) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.frequency",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.frequencyLabel(item)) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.recipients",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            disabled: !(
                              item.recipients && item.recipients.length
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "recipients-cell text-truncate"
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              (item.recipients || []).join(", ")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm._l(item.recipients || [], function(recipient, i) {
                            return _c("div", { key: i }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(recipient) +
                                  "\n          "
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ]
                  }
                },
                {
                  key: "item.active",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("v-switch", {
                        staticClass: "ma-0 pa-0 d-inline-flex",
                        attrs: {
                          "input-value": item.active,
                          color: "success",
                          dense: "",
                          "hide-details": "",
                          ripple: false
                        },
                        on: {
                          change: function($event) {
                            return _vm.toggleActive(item)
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: "item.actions",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          staticClass: "mr-3",
                                          attrs: { small: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.editSchedule(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-pencil")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v("Edit")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          attrs: { small: "", color: "error" },
                                          on: {
                                            click: function($event) {
                                              return _vm.promptDelete(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-delete")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v("Delete")])]
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mt-4 mb-4" }),
          _vm._v(" "),
          !_vm.loading && _vm.templates.length === 0
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: { dense: "", text: "", type: "info" }
                },
                [
                  _vm._v(
                    "\n      You have no saved export templates yet. Create one in the Templates tab to schedule its delivery.\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "schedule-form" },
            [
              _c("div", { staticClass: "subtitle-2 mb-2" }, [
                _vm._v(_vm._s(_vm.editingId ? "Edit schedule" : "New schedule"))
              ]),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.templates,
                          "item-text": "name",
                          "item-value": "template_id",
                          label: "Template",
                          dense: "",
                          outlined: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.form.template_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "template_id", $$v)
                          },
                          expression: "form.template_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.frequencyOptions,
                          label: "Frequency",
                          dense: "",
                          outlined: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.form.frequency,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "frequency", $$v)
                          },
                          expression: "form.frequency"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _vm.form.frequency === "weekly"
                        ? _c("v-select", {
                            attrs: {
                              items: _vm.weekdayOptions,
                              label: "Day of week",
                              dense: "",
                              outlined: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.form.day_of_week,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "day_of_week", $$v)
                              },
                              expression: "form.day_of_week"
                            }
                          })
                        : _vm.form.frequency === "monthly"
                        ? _c("v-text-field", {
                            attrs: {
                              type: "number",
                              min: "1",
                              max: "31",
                              label: "Day of month",
                              dense: "",
                              outlined: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.form.day_of_month,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "day_of_month", _vm._n($$v))
                              },
                              expression: "form.day_of_month"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-combobox", {
                        attrs: {
                          "search-input": _vm.recipientInput,
                          label: "Recipients",
                          multiple: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          "append-icon": ""
                        },
                        on: {
                          "update:searchInput": function($event) {
                            _vm.recipientInput = $event
                          },
                          "update:search-input": function($event) {
                            _vm.recipientInput = $event
                          }
                        },
                        model: {
                          value: _vm.form.recipients,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "recipients", $$v)
                          },
                          expression: "form.recipients"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.error
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pt-0", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "error--text caption" }, [
                            _vm._v(_vm._s(_vm.error))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _vm.editingId
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-4",
                  attrs: { text: "" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v("Cancel edit")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                loading: _vm.saving,
                disabled: !_vm.canSave
              },
              on: { click: _vm.saveSchedule }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.editingId ? "Update" : "Create") +
                  "\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420" },
          model: {
            value: _vm.showDeleteConfirm,
            callback: function($$v) {
              _vm.showDeleteConfirm = $$v
            },
            expression: "showDeleteConfirm"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v("Delete scheduled delivery?")
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        This will stop the recurring delivery of\n        "
                ),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.pendingDelete
                        ? _vm.templateName(_vm.pendingDelete.template_id)
                        : ""
                    )
                  )
                ]),
                _vm._v(".\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.showDeleteConfirm = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", text: "" },
                      on: { click: _vm.confirmDelete }
                    },
                    [_vm._v("Delete")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec80fb5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec80fb5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduledExportsPanel.vue
// module id = null
// module chunks = 